<template>
  <v-container fluid class="px-0 py-0">
    <v-tabs v-model="active">
      <v-tab>课次消费记录</v-tab>
      <v-tab>历史课次消费记录</v-tab>
      <v-tab-item>
        <template v-if="crudCfg1">
          <crud :cfg="crudCfg1" />
        </template>
      </v-tab-item>
      <v-tab-item>
        <template v-if="crudCfg2">
          <crud :cfg="crudCfg2" />
        </template>
      </v-tab-item>
    </v-tabs>
  </v-container>
</template>
<script>
import { Crud } from "javaee-fre";
export default {
  name: "recharge-logs",
  components: {
    crud: Crud,
  },
  props: {
    cfg: Object,
  },
  watch: {
    active(i) {
      let self = this,
        cfg = self.cfg || self.$route.meta;
      if (!cfg) {
        return;
      }
      if (i == 1 && !self.crudCfg2) {
        let rid = cfg._rid || self.$route.params._rid,
          url = cfg.url || "/home/admin/sys/recharge/log";
        self.crudCfg2 = {
          url: url,
          params: { _rid: rid, _a: "true" },
          listActions: [
            {
              label: "导出",
              func() {
                let self = this,
                  exportUrl = `${self.$const.baseUrl}${url}/export.xlsx?_rid=${rid}&_a=true`;
                if (self.searching) {
                  exportUrl = `${exportUrl}&${self.$qs.stringify(self.searchData())}`;
                }
                window.open(exportUrl, "_blank");
              },
            },
          ],
        };
      }
    },
  },
  data() {
    return { crudCfg1: null, crudCfg2: null, active: 0 };
  },
  methods: {
    init() {
      let self = this,
        cfg = self.cfg || self.$route.meta;
      if (!cfg) {
        return;
      }
      let rid = cfg._rid || self.$route.params._rid,
        url = cfg.url || "/home/admin/sys/recharge/log";
      self.crudCfg1 = {
        url: url,
        params: { _rid: rid },
        listActions: [
          {
            label: "导出",
            func() {
              let self = this,
                exportUrl = `${self.$const.baseUrl}${url}/export.xlsx?_rid=${rid}`;
              if (self.searching) {
                exportUrl = `${exportUrl}&${self.$qs.stringify(self.searchData())}`;
              }
              window.open(exportUrl, "_blank");
            },
          },
        ],
      };
    },
  },
  created() {
    this.init();
  },
};
</script>